import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const blogPosts = [
  {
    id: "02",
    title: "The best tech stack for building a mobile app",
    date: "2026-10-22",
  },
  {
    id: "01",
    title: "I built an AI integration in 1 weekend",
    date: "2026-10-18",
  },
];

function BlogPost() {
  const { id } = useParams();
  const navigate = useNavigate();
  const post = blogPosts.find((p) => p.id === id);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!post) return;
    setLoading(true);
    fetch(`/blogs/${id}.html`)
      .then((res) => {
        if (!res.ok) throw new Error("Not found");
        return res.text();
      })
      .then((html) => {
        setContent(html);
        setLoading(false);
      })
      .catch((err) => {
        setError("Blog post content not found.");
        setLoading(false);
      });
  }, [id, post]);

  if (!post) {
    return <div style={{ padding: "2rem" }}>Blog post not found.</div>;
  }

  return (
    <section className="blog-post-section">
      <button
        className="blog-back"
        onClick={() => navigate(-1)}
        aria-label="Back to blog list"
      >
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: "0.5em" }} />
        Back
      </button>
      <h2 className="blog-post-title">{post.title}</h2>
      <div className="blog-post-date">
        {new Date(`${post.date}T00:00:00`).toLocaleDateString()}
      </div>
      <div className="blog-post-content">
        {loading && <em>Loading...</em>}
        {error && <span style={{ color: "#c00" }}>{error}</span>}
        {!loading && !error && (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        )}
      </div>
    </section>
  );
}

export default BlogPost;
